import { useEffect, useState } from 'react';
import { once } from 'lodash-es';
import { useOtherSettings } from '@namespace/cms';
import { get } from '@namespace/helpers';

const fetchRegions = once((path) => get(path));

export const useRegions = () => {
  const { regionsAndCitiesPath } = useOtherSettings();
  const [options, setOptions] = useState([]);

  useEffect(() => {
    (async () => {
      const r = await fetchRegions(regionsAndCitiesPath);
      setOptions(r || []);
    })();
  }, [regionsAndCitiesPath]);

  return options;
};
